import {
  createValidator,
  equal
} from '../../../../util/form/validation';

export const fields = [
  'acceptedVerifications',
  'acceptedContracts',
  'contractsAvailable',
  'verificationRequired'
];

export const validation = createValidator({
  'acceptedContracts': [
    equal(true, 'Please accept the terms and agreements')
  ]
  // 'acceptedVerifications': [equal(true, 'Please verify you are 18 or older', [[{'name' : 'verificationRequired', 'value': true}]])],
});

//
// export const normalizeCart = (state, currentPath) => {
//   if (_.isEmpty(state.cart.cart)) {
//     return state.cart.cart;
//   }
//
//   const rawCart = state.cart.cart;
//   const routes = getRoutes(state, currentPath);
//
//   // TODO: This is not the most productive way to do these ckecks with the empty array, we should probably not
//   // try to fill these variables if detailedCart isn't here
//
//   const currentSections = rawCart.detailedCart ? rawCart.detailedCart.cartSections
//     .filter(
//       cart => apiTypeToNavigationRoute(cart.customizationType) === routes.currentRoute
//     ) : [];
//
//   // This will only work if one of the installation types has a 0 amount
//   // otherwise we will need to track the current selection and return the correct sub total
//   const currentSubTotal = currentSections.length > 0 ? currentSections
//     .map(section => section.sectionTotalPrice)
//     .reduce((a, b) => {
//       const cents = (Number(a.cents) + Number(b.cents));
//       const rem = Math.floor(cents / 100);
//       const dollars = Number(a.dollars) + Number(b.dollars) + rem;
//
//         return {
//           dollars: (dollars).toString(),
//           cents: formatCents((cents % 100).toString())
//         };
//     }) : [{dollars: "0", cents: "00"}];
//
//   // Currently either SIK or PRO could contain the false value we are looking for so we search for it in
//   // both places and display accordingly
//   const displaySelectionRequired = _(currentSections).map('displaySelectionRequired').indexOf(false) === -1;
//
//   const cartItems = currentSections.length > 0 ? currentSections
//     .map(section => section.cartSectionItems)
//     .reduce((a, b) => a.concat(b), [])
//     .filter((a) => a.displayInCart) : [];
//
//   const cartSummaryItems = rawCart.summaryCart ? rawCart.summaryCart.cartItems : [];
//   const showSummary = state.cart.showSummary && !routes.currentRoute.disableSummary;
//
//   const selectedPaymentOption = getPaymentOptionForState(state, paymentOptionsStates.ACTIVE);
//   const dueToday = rawCart.hybridCart ? deriveDueToday(state, routes, selectedPaymentOption) : null;
//
//   return {
//     ...rawCart,
//     displaySelectionRequired,
//     currentSubTotal,
//     cartItems,
//     cartSummaryItems,
//     currentRoute: routes.currentRoute,
//     nextRoute: routes.nextRoute,
//     prevRoute: routes.prevRoute,
//     cartTabsRoutes: routes.cartTabsRoutes,
//     showSummary,
//     dueToday
//   };
// };



/** WEBPACK FOOTER **
 ** ./client/redux/modules/data/review/reviewHelpers.js
 **/